<template>
  <v-app >

    <v-main style="background-color: #24292d; font-family: 'Poppins', sans-serif !important;">
      <cabecerabaja class=" hidden-md-only hidden-lg-only hidden-xl-only" />

      <v-container>
        <v-row >
          <v-col md="12" lg="12" cols="12">

            <v-alert
                :value="alertborrador"
                color="red"
                dark
                dismissible
                border="top"
                transition="scale-transition"
            >
              Su Cliente se borro con éxito.
            </v-alert>
            <v-alert
                :value="alertnuevo"
                color="primary"
                dark
                dismissible
                border="top"
                transition="scale-transition"
            >
              Su Cliente se agrego con éxito.
            </v-alert>
            <v-alert
                :value="alerteditar"
                color="green"
                dark
                dismissible
                border="top"
                transition="scale-transition"
            >
              Su Cliente se edito con éxito.
            </v-alert>

            <v-dialog v-model="edialog" max-width="500px">
              <template v-slot:activator="{ on }">
                <v-btn color="primary" dark class="mb-2" v-on="on">Nuevo Cliente</v-btn>
              </template>
              <v-card color="#393E46">
                <v-card-title>
                  <span class="headline">{{ formTitle }}</span>
                </v-card-title>
                <v-card-text>
                  <v-container>
                    <v-row>
                      <v-col cols="12" sm="12" md="12">
                        <v-text-field v-model="editedItem.cliente" label="Nombre"></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="12" md="12">
                        <v-text-field v-model="editedItem.razonSocial" label="Razon Social" ></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="12" md="12">
                        <v-text-field v-model="editedItem.ruc" label="RUC" ></v-text-field>
                      </v-col>

                      <v-col cols="12" sm="12" md="12">
                        <v-text-field v-model="editedItem.emailC" label="Email" ></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="12" md="12">
                        <v-autocomplete label="Escoger Pais"
                        :items="Paises"
                        v-model="editedItem.pais"
                          item-text="pais"
                          return-object
                        >
                        </v-autocomplete>
                      </v-col>
                      <v-col cols="12" sm="12" md="12">
                        <v-autocomplete label="Escoger Zona Horaria"
                        :items="TimeZones"
                         return-object
                          v-model="editedItem.timeZone"
                         item-text="timeZone"
                        >
                        </v-autocomplete>
                      </v-col>
                      <v-col cols="12" sm="12" md="12">
                        <v-textarea v-model="editedItem.mensaje" label="Mensaje" ></v-textarea>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="blue darken-1" text @click="close">Cancelar</v-btn>
                  <v-btn color="blue darken-1" text @click="save">Grabar</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
            <v-dialog v-model="dialogdelete" persistent max-width="350">
              <v-card color="#393E46">
                <v-card-title class="headline">Desea eliminar esta Cliente?</v-card-title>
                <v-card-text>Estos datos no se volveran a visualizar en el sistema.</v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="green darken-1" text @click="close">No</v-btn>
                  <v-btn color="primary darken-1" text @click="borralo">SI</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
            <v-dialog v-model="dialoguploadfoto"  persistent max-width="600">
              <v-card color="#393E46">
                <v-card-title class="headline">Flyer del Cliente</v-card-title>
                <v-card-text>
                  <v-row>
                    <v-col md="12" lg="12" cols="12">
                      <v-img :src="editedItem.foto"  />
                    </v-col>
                    <v-col md="12" lg="12" cols="12">
                      <v-file-input
                          label="Subir Nuevo Flyer"
                          accept="image/*"
                          filled
                          chips
                          v-model="imagen"
                          @change="onFileChange"
                          prepend-icon="mdi-camera"
                      ></v-file-input>
                    </v-col>
                  </v-row>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="green darken-1" text @click="dialoguploadfoto=false">Cerrar</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>


            <div >
              <v-data-table
                  :headers="headers"
                  :items="Clientes"
                  sort-by="Cliente"
                  sort-desc
                  class="elevation-1"
                  :search="search"
                  :loading="progr"
                  no-data-text="No hay datos disponibles para mostrar."
                  no-results-text="No hay resultados para la búsqueda."
                  loading-text="Cargando... Por favor espere."
                  style="background-color: #393E46;"
              >
                <template v-slot:top>
                  <v-toolbar flat >
                    <v-toolbar-title>Clientes</v-toolbar-title>
                    <v-progress-circular
                        indeterminate
                        v-if="progr == true"
                        color="primary"
                    ></v-progress-circular>
                    <v-divider
                        class="mx-4"
                        inset
                        vertical
                    ></v-divider>
                    <v-text-field v-model="search" label="Buscar" class="mx-4"></v-text-field>
                    <v-spacer></v-spacer>


                  </v-toolbar>
                </template>
                <template v-slot:[`item.action`]="{ item }">
                  <v-icon
                      small
                      color="primary"
                      class="mr-2"
                      @click="editItem(item)"
                  >
                    fas fa-edit
                  </v-icon>
                  <v-icon
                      small
                      color="error"
                      class="mr-2"
                      @click="deleteItem(item)"
                  >
                    fas fa-minus-circle
                  </v-icon>
                  <v-icon
                      small
                      color="#f7be64"
                      class="mr-2"
                      @click="fotoItem(item)"
                  >
                    fas fa-camera-retro
                  </v-icon>
                </template>

                <template v-slot:[`item.activ`]="{ item }">
                  <v-switch v-model="item.deuda" @click="activaCliente(item)" ></v-switch>
                </template>

                <template v-slot:[`item.activev`]="{ item }">
                  <v-switch v-model="item.eventos" @click="activaCliente(item)" ></v-switch>
                </template>

                <template v-slot:[`item.activcb`]="{ item }">
                  <v-switch v-model="item.clubs" @click="activaCliente(item)" ></v-switch>
                </template>

                <template v-slot:no-data>
                  <v-btn color="primary" @click="dameClientes">Cargar de Nuevo</v-btn>
                </template>
              </v-data-table>
            </div>

          </v-col>
        </v-row>
        <leftmenusuperadmin />
        <v-overlay :value="overlay">
          <v-progress-circular
              indeterminate
              size="64"
          ></v-progress-circular>
        </v-overlay>
      </v-container>
    </v-main>
  </v-app>
</template>
<script>
import { mapGetters } from "vuex";
import axios from 'axios';
import moment from "moment";
import leftmenusuperadmin from "@/components/general/leftmenusuperadmin";
import store from "@/store";
import firebase from 'firebase/compat/app';
import Cabecerabaja from "@/components/general/cabecerabaja";

export default {
  title: 'Clientes | Tunay Mi acceso de bolsillo',

  components: {
    Cabecerabaja,
    leftmenusuperadmin
  },
  data: () => ({
    vistatabla: false,
    drawer: null,
    overlay:false,
    progr: true,
    token:'',
    alertborrador: false,
    alertnuevo: false,
    alerteditar: false,
    dialog: false,
    categoriafiesta: 0,
    tipoevento: 0,
    steps: 4,
    e1: 1,
    imagen:null,
    edialog: false,
    confdialog: false,
    dialogdelete: false,
    dialogcontactos: false,
    date: new Date().toISOString().substr(0, 10),
    date2: new Date().toISOString().substr(0, 10),
    dialoguploadfooter: false,
    dialoguploadcabecera: false,
    dialoguploadfoto: false,
    menu1: false,
    menu2: false,
    menu3: false,
    modal3: false,
    modal4: false,
    menu4: false,
    time: null,
    time2: null,
    Clientes: [],
    CategoriaClientes: [],
    TipoClientes: [],
    eventoId: 0,
    TimeZones:[],
    Paises:[],
    search: '',
    editedIndex: -1,
    editedItem: {
      cliente: "",
      logo: "",
      razonSocial:"",
      pais: {},
      ruc: "",
      deuda: false,
      clubs: false,
      eventos: false,
      tag: "",
      createdAt: null,
      timeZone: {},
      emailC: "",
      mensaje: "",
    },
    defaultItem: {
      id: 0,
      cliente: "",
      logo: "",
      razonSocial:"",
      pais: {},
      ruc: "",
      deuda: false,
      clubs: false,
      eventos: false,
      tag: "",
      createdAt: null,
      timeZone: {},
      emailC: "",
      mensaje: "",
    },
    headers: [
      { text: 'Acciones', value: 'action', sortable: false },
      { text: 'Cliente', align: 'left',  value: 'cliente'},
      { text: 'Razon Social', align: 'left',  value: 'razonSocial'},
      { text: 'Ruc', align: 'left',  value: 'ruc'},
      { text: 'Deuda', value: 'activ', sortable: false },
      { text: 'Eventos', value: 'activev', sortable: false },
      { text: 'Clubs', value: 'activcb', sortable: false }

    ]
  }),
  mounted (){

       this.token = firebase.auth().currentUser.auth.currentUser.accessToken;
        this.dameClientes();

  },
  watch: {
    dialog (val) {
      val || this.close()
    }
  },
  methods : {
    formatDatee(value) {
      return moment(value).locale('es-pe').format("DD MMMM YYYY")
    },

    damepaises(){
      this.overlay = true;
      this.progr = true;
      let urlPaises = 'paises';
      axios
          .get(urlPaises,{
            headers: {
              'Authorization': `Bearer ${this.token}`,
            }
          })
          .then(response => {
            this.Paises = response.data;
            this.progr = false;
            this.alertborrador = false;
            this.alertnuevo = false;
            this.alerteditar = false;
            this.overlay = false;
          })
          .catch((error)  => {
            console.log(error);
            this.progr = false;
          });
    },
    dameTimeZones(){
      this.overlay = true;
      this.progr = true;
      let urlTimeZone = 'general/timezones';
      axios
          .get(urlTimeZone,{
            headers: {
              'Authorization': `Bearer ${this.token}`,
            }
          })
          .then(response => {
            this.TimeZones = response.data;
            this.damepaises();
            this.progr = false;
            this.alertborrador = false;
            this.alertnuevo = false;
            this.alerteditar = false;
            this.overlay = false;
          })
          .catch((error)  => {
            console.log(error);
            this.progr = false;
          });
    },
    dameClientes(){
      this.overlay = true;
      this.progr = true;
      let urlCliente = 'clientes';
      axios
          .get(urlCliente,{
            headers: {
              'Authorization': `Bearer ${this.token}`,
            }
          })
          .then(response => {
            this.Clientes = response.data;
            this.dameTimeZones();
            this.progr = false;
            this.alertborrador = false;
            this.alertnuevo = false;
            this.alerteditar = false;
            this.overlay = false;
          })
          .catch((error)  => {
            console.log(error);
            this.overlay = false;
            this.progr = false;
          });
    },
    formatDate (date) {
      return moment(date).locale('es-pe').format("YYYY-MM-DD");
    },
    formatDatree(value) {
      return moment(value).locale('es-pe').format("DD-MM-YYYY")
    },
    irpaso1(){
      this.$router.push({name:'CreaPaso1'});
    },
    formatTime (date) {
      let hora = new Date('2020-10-10 '+date)
      return moment(hora).locale('es-pe').format("HH:mm");
    },
    parseDate (date) {
      if (!date) return null

      const [day,month, year] = date.split('/')
      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
    },
    onFileChange(e) {
      this.editedItem.foto= URL.createObjectURL(this.imagen)
      var bodyFormData = new FormData();
      bodyFormData.append("file",this.imagen);
      let url = "eventos/foto/" + this.editedItem.id
      this.overlay = true
      axios
          .post(url,bodyFormData,{
            headers: {
              'Authorization': `Bearer ${this.token}`,
            }
          })
          .then(response => {
            console.assert(true,response);
            this.dialoguploadfoto = false;
            this.overlay = false
          })
          .catch(error => {
            this.error = "Hubo un error";
            console.log(error);
          });
      console.log(e)
    },

    activaCliente (item) {
      this.editedItem = Object.assign({}, item)
      var bodyFormData2 = new FormData();
      bodyFormData2.append("data",JSON.stringify(this.editedItem));
      axios
          .post('clientes/grabar',bodyFormData2,{
            headers: {
              'Authorization': `Bearer ${this.token}`,
            }
          }).then(response => {
        console.log(response);
      })
          .catch(error => {
            this.error = "Hubo un error";
            console.log(error);
          });
    },
    editItem (item) {
      this.editedIndex = this.Clientes.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.edialog = true
    },
    cabeceraItem(item){
      this.editedIndex = this.Clientes.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.dialoguploadcabecera = true
    },
    footerItem(item){
      this.editedIndex = this.Clientes.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.dialoguploadfooter = true
    },
    contactosItem(item){
      this.editedIndex = this.Clientes.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.dialogcontactos = true
      this.contactosevento(this.editedItem.id)
    },
    fotoItem(item){
      this.editedIndex = this.Clientes.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.dialoguploadfoto = true
    },
    configItem (item) {
      this.editedIndex = this.Clientes.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.confdialog = true
    },
    deleteItem (item) {
      this.editedIndex = this.Clientes.indexOf(item);
      this.dialogdelete = true;
    },
    irZona(item){
      this.editedIndex = this.Clientes.indexOf(item);
      this.editedItem = Object.assign({}, item)
      store.dispatch("fetchCliente", this.editedItem);

      this.$router.push({name:'ZonaCliente'})
    },
    irEntradas(item){
      this.editedIndex = this.Clientes.indexOf(item);
      this.editedItem = Object.assign({}, item)
      store.dispatch("fetchCliente", this.editedItem);
      this.$router.push({name:'TicketCliente'})
    },
    close () {
      this.dialog = false;
      this.edialog = false;
      this.confdialog = false;
      this.dialogdelete = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      }, 300)
    },
    graba(item){
      var bodyFormData2 = new FormData();
      item.fechaInicio = this.formatDatree(item.fechaInicio)
      item.fechaFinal = this.formatDatree(item.fechaFinal)
      bodyFormData2.append("data",JSON.stringify(item));
      axios
          .post('eventos/grabaevento',bodyFormData2,{
            headers: {
              'Authorization': `Bearer ${this.token}`,
            }
          }).then(response => {
        this.Clientes = response.data
        this.alerteditar = true;

      })
          .catch(error => {
            this.error = "Hubo un error";
            console.log(error);
          });
    },
    save () {
      var bodyFormData2 = new FormData();
      if (this.editedIndex > -1) {
        Object.assign(this.Clientes[this.editedIndex], this.editedItem);
        bodyFormData2.append("data",JSON.stringify(this.editedItem));

        axios
            .post('clientes/grabar',bodyFormData2,{
              headers: {
                'Authorization': `Bearer ${this.token}`,
              }
            }).then(response => {
          this.Clientes = response.data
          this.alerteditar = true;
          this.overlay = false
        })
            .catch(error => {
              this.error = "Hubo un error";
              console.log(error);
              this.overlay = false
            });
      } else {
        bodyFormData2.append("data",JSON.stringify(this.editedItem));
      this.overlay = true
        axios
            .post('clientes/new',bodyFormData2,{
              headers: {
                'Authorization': `Bearer ${this.token}`,
              }
            }).then(response => {

          this.alertnuevo = true;
          this.overlay = false
          this.Clientes = response.data
        })
            .catch(error => {
              this.error = "Hubo un error";
              this.overlay = false
              console.log(error);
            });
      }
      this.close()
    },
  },
  computed: {
    // map `this.user` to `this.$store.getters.user`
    formTitle () {
      return this.editedIndex === -1 ? 'Nueva Cliente' : 'Editar Cliente'
    },
    computedDateFormatted () {
      return this.formatDate(this.date)
    },
    ...mapGetters({
      user: "user",
      usuario: "usuario",
      cliente: "cliente"
    })
  }
};
</script>